var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_72430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4462 17.9551C6.35461 22.1645 4.12241 26.9417 2.87704 32.0138C1.63167 37.0859 1.39753 42.3537 2.18798 47.5163C2.97843 52.6789 4.77799 57.6353 7.48392 62.1024C10.1898 66.5696 13.7491 70.46 17.9586 73.5516C22.1681 76.6432 26.9452 78.8754 32.0174 80.1208C37.0895 81.3661 42.3572 81.6003 47.5199 80.8098C52.6825 80.0194 57.6388 78.2198 62.106 75.5139C66.5731 72.808 70.4636 69.2487 73.5552 65.0392C76.6467 60.8298 78.879 56.0526 80.1243 50.9805C81.3697 45.9083 81.6038 40.6406 80.8134 35.478C80.0229 30.3153 78.2234 25.359 75.5174 20.8918C72.8115 16.4247 69.2522 12.5342 65.0428 9.44265C60.8333 6.35106 56.0561 4.11886 50.984 2.87349C45.9119 1.62812 40.6441 1.39398 35.4815 2.18443C30.3189 2.97488 25.3625 4.77444 20.8954 7.48037C16.4282 10.1863 12.5378 13.7456 9.4462 17.9551Z",
    fill: "var(--svg-secondary-color, #DDE5FF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9566 73.554C9.45527 67.3103 3.7824 57.9451 2.18602 47.5187C0.589637 37.0924 3.2005 26.4589 9.44425 17.9575C15.688 9.45612 25.0532 3.78325 35.4796 2.18687C45.9059 0.590484 56.5394 3.20135 65.0408 9.44509L17.9566 73.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72852 41.4966C1.72852 46.7194 2.75722 51.891 4.75589 56.7162C6.75456 61.5415 9.68406 65.9258 13.3771 69.6188C17.0702 73.3119 21.4545 76.2414 26.2797 78.2401C31.1049 80.2387 36.2766 81.2674 41.4994 81.2674C46.7221 81.2674 51.8938 80.2387 56.719 78.2401C61.5442 76.2414 65.9285 73.3119 69.6216 69.6188C73.3146 65.9258 76.2441 61.5415 78.2428 56.7162C80.2415 51.891 81.2702 46.7194 81.2702 41.4966C81.2702 36.2738 80.2415 31.1022 78.2428 26.277C76.2441 21.4517 73.3146 17.0674 69.6216 13.3744C65.9285 9.68131 61.5442 6.75182 56.719 4.75314C51.8938 2.75447 46.7221 1.72577 41.4994 1.72577C36.2766 1.72577 31.1049 2.75447 26.2797 4.75314C21.4545 6.75182 17.0702 9.68131 13.3771 13.3744C9.68406 17.0674 6.75456 21.4517 4.75589 26.277C2.75722 31.1022 1.72852 36.2738 1.72852 41.4966Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25 24.2049L38.0417 57.0591L20.75 43.2257",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_72430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmation-icon.c4944997ac2044cbc5fa22886fce4020.svg";
export { ForwardRef as ReactComponent };